import { BaseSvgIcon } from './BaseSvgIcon'

export const BreastRightIcon = (props: any) => {
  const { width = 66, height = 80, ...rest } = props

  return (
    <BaseSvgIcon width={width} height={height} viewBox="0 0 66 80" {...rest}>
      <path
        d="M64.2875 48.2515C65.7461 42.2488 65.5858 36.2346 65.5851 30.1177L65.5853 7.99817C65.5892 5.51772 65.9584 4.96206 64.0332 2.96281C61.8219 0.666422 58.1726 0.581792 55.789 2.70808C54.4573 3.89594 54.4549 5.32137 54.4116 6.93877C54.3011 9.54029 54.8218 15.0367 53.9128 17.2C52.3098 21.0147 48.0905 21.0733 44.5018 21.7359C32.3772 23.9747 18.7873 28.9272 12.3847 39.6196C11.1033 41.7589 10.0658 44.1538 9.94875 46.6425C9.32535 59.9045 20.5527 71.2287 34.4633 71.6687C48.1012 72.1003 61.8684 60.9022 64.2875 48.2515Z"
        fill="white"
      />
      <path
        d="M64.2875 48.2515C65.7461 42.2488 65.5858 36.2346 65.5851 30.1177L65.5853 7.99817C65.5892 5.51772 65.9584 4.96206 64.0332 2.96281C61.8219 0.666422 58.1726 0.581792 55.789 2.70808C54.4573 3.89594 54.4549 5.32137 54.4116 6.93877C56.0619 5.43241 56.7191 2.86463 59.5433 2.86135C64.1276 2.85605 63.6044 8.00616 63.6002 10.8626L63.5983 32.1004C63.5973 35.9319 63.6869 39.4535 63.8186 43.2539C63.8522 44.2244 63.542 47.6778 64.2875 48.2515Z"
        fill="black"
      />
      <path
        d="M2.0432 50.5074C-0.132938 50.7236 0.240391 52.0513 0.419518 53.6009C1.73017 64.9697 13.5934 78.1388 26.0494 79.076C28.7504 79.3578 27.6741 77.1175 27.2633 76.988C26.6362 76.7903 25.9006 76.7474 25.2478 76.6473C14.7746 75.0363 6.38128 65.8648 3.50282 56.5571C3.05944 55.1253 2.79074 50.807 2.0432 50.5074Z"
        fill="black"
      />
    </BaseSvgIcon>
  )
}
